module.exports = __webpack_public_path__ + "static/media/image-5.45e85c59.jpg";